/* global modForm */
/**
 * Hide all step DOM elements.
 */
export function hideAllSteps() {
	modForm.opts.steps.forEach(function(step) {
		if (step.classList.contains(modForm.opts.stepActiveCls)) {
			step.classList.remove(modForm.opts.stepActiveCls);
		}
		if (modForm.opts.addAccessibilityUpdates && !modForm.opts.useGlobalInitCarousel) {
			step.setAttribute('aria-hidden', 'true');
			step.setAttribute('tabindex', '-1');
		}
	});
}
